import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import {
  Button,
  Typography,
  TextField,
  Switch,
  FormControlLabel,
  Box,
} from '@mui/material';
import { useFormContext } from 'react-hook-form';
import FormSelect from '../../../../../Components/Form/FormSelect';

const NewCtaTab = function NewCtaTab({ tab = 0, tags = [], icons = [] }) {
  const intl = useIntl();
  const { register, formState } = useFormContext();
  const [label, setLabel] = useState('');
  const [showIcon, setShowIcon] = useState(false);
  const [message, setMessage] = useState(
    intl.messages.ANSWER_REGISTERED_MESSAGE
  );

  const handleChangeLabel = (event) => {
    setLabel(event.target.value);
  };

  const handleChangeMessage = (event) => {
    setMessage(event.target.value);
  };

  const handleChangeShowIcon = (event) => {
    setShowIcon(event.target.checked);
  };

  return (
    <>
      <Button
        onClick={() => {}}
        variant="contained"
        // endIcon={icon}
        size="large"
        sx={{ alignSelf: 'center', m: '8px' }}
      >
        {label || intl.messages.INSERT_TEXT}
      </Button>
      <Typography variant="subtitle1">{intl.messages.EDIT_DETAILS}:</Typography>
      {icons.length > 0 && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            width: '100%',
          }}
        >
          <FormControlLabel
            control={
              <Switch checked={showIcon} onChange={handleChangeShowIcon} />
            }
            label={intl.messages.ICON}
          />
          {showIcon && <FormSelect name="icon" options={icons} noHelper />}
        </Box>
      )}
      <TextField
        id="label-txtfield"
        {...register('text', {
          required: tab === 0,
        })}
        error={formState?.errors?.text}
        placeholder={intl.messages.INSERT_TEXT}
        value={label}
        onChange={handleChangeLabel}
        required={tab === 0}
      />
      <FormSelect
        name="tagId"
        options={tags.map(({ id }) => id)}
        noTranslation
        required={tab === 0}
        noHelper
      />
      <TextField
        {...register('responseText', {
          required: tab === 0,
        })}
        error={formState?.errors?.responseText}
        id="response-txtfield"
        multiline
        placeholder={intl.messages.INSERT_TEXT}
        value={message}
        onChange={handleChangeMessage}
        required={tab === 0}
      />
    </>
  );
};

export default NewCtaTab;
